import { notifications } from '@mantine/notifications';
import { errorMessage } from '../api/client';

export function notifySuccess(message: string, title?: string): void {
  notifications.show({ color: 'green', title, message, autoClose: 3500 });
}

export function notifyError(error: unknown, title = 'Error'): void {
  notifications.show({ color: 'red', title, message: errorMessage(error), autoClose: 7000 });
}
